module.exports = __webpack_public_path__ + "img/thank_you_robot.95d656f8.svg";